import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Grid, Popup, Button, Input, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const INITIAL_STATE = {
  'isOpen': false,
  'model': '',
  'katashiki': '',
  'brand': '',
};

class CompatibilityModal extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleOpenClick = this.handleOpenClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  parseGreyCarModels() {
    const {partGreyCarModels} = this.props;

    return partGreyCarModels.map((model, index) => ({
      'key': index,
      'text': model.toUpperCase(),
      'value': model.toUpperCase(),
    }));
  }

  renderTrigger() {
    return (
      <Popup
        inverted
        position='top center'
        content='Registro Manual'
        trigger={
          <Button
            circular
            type='button'
            color='blue'
            icon='columns'
            onClick={this.handleOpenClick}
          />
        }
      />
    );
  }

  handleOpenClick(event) {
    event.preventDefault();
    this.setState({'isOpen': true});
  }

  handleCloseClick() {
    this.setState(INITIAL_STATE);
  }

  handleSaveClick() {
    const {model, katashiki, brand} = this.state;
    const {partCode, franchise} = this.props;

    if (model && katashiki && brand) {
      this.props.savePartCarCompatibility(partCode, {
        model,
        katashiki,
        brand,
        franchise,
      });
    }

    this.handleCloseClick();
  }

  handleFieldChange(event, data) {
    const {name, value} = data;

    this.setState({[name]: value.toUpperCase()});
  }

  render() {
    const {isOpen, model, katashiki, brand} = this.state;
    const {loadingPartGreyCarModels} = this.props;

    return (
      <Modal className='parts-master' open={isOpen} trigger={this.renderTrigger()}>
        <Modal.Header>Ingreso Manual</Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width='8'>
                <label>
                  <strong>Modelo</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  search
                  name='model'
                  value={model}
                  disabled={loadingPartGreyCarModels}
                  loading={loadingPartGreyCarModels}
                  options={this.parseGreyCarModels()}
                  onChange={this.handleFieldChange}
                  error={!model}
                />
              </Grid.Column>
              <Grid.Column width='8'>
                <label>
                  <strong>Katashiki</strong>
                </label>
                <Input
                  fluid
                  name='katashiki'
                  value={katashiki}
                  onChange={this.handleFieldChange}
                  error={!katashiki}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='8'>
                <label>
                  <strong>Marca</strong>
                </label>
                <Input
                  fluid
                  name='brand'
                  value={brand}
                  onChange={this.handleFieldChange}
                  error={!brand}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCloseClick}>
            Cancelar
          </Button>
          <Button primary onClick={this.handleSaveClick}>
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partCode': state.partsMaster.values.partCode,
    'franchise': state.partsMaster.values.franchise,
    'loadingPartGreyCarModels': state.partsMaster.loadingPartGreyCarModels,
    'partGreyCarModels': state.partsMaster.partGreyCarModels,
  };
};

const {savePartCarCompatibility} = Actions;

export default connect(mapStateToProps, {savePartCarCompatibility})(
  CompatibilityModal
);
